import { render, staticRenderFns } from "./AverageListsByClient.vue?vue&type=template&id=d870c748"
import script from "./AverageListsByClient.vue?vue&type=script&lang=js"
export * from "./AverageListsByClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports